import axios from '@/api/tool'


/**
 * 文件查询
 */
export function getModuleFiles(data) {
  return axios({
    url: '/common/file/getModuleFiles',
    method: 'post',
    data: data
  })
}

/**
 * 字典查询
 */
export function getDict(query) {
  return axios({
    url: '/common/dict/queryDictData',
    method: 'get',
    params: query
  })
}

/**
 * 分类字典查询
 */
export function queryCascadeDict01(query) {
  return axios({
    url: '/common/dict/queryCascadeDict01',
    method: 'get',
    params: query
  })
}

/**
 * 根据code查询下级
 * @param query
 */
export function queryDictDataByTypeAndCode(query) {
  return axios({
    url: '/common/dict/queryDictDataByTypeAndCode',
    method: 'get',
    params: query
  })
}

/**
 * 根据pid查询省
 * @param query
 */
export function getDistrictByParentId(query) {
  return axios({
    url: '/common/district/getDistrictByParentId',
    method: 'get',
    params: query
  })
}

/**
 * 根据key查询省
 * @param query
 */
export function getDistrictByKey(query) {
  return axios({
    url: '/common/district/getDistrictByKey',
    method: 'get',
    params: query
  })
}

/**
 * 国高新列表
 * @param data
 * @returns {number}
 */
export function queryHighTechApproval(data) {
  return axios({
    url: '/highTechApproval/queryHighTechApproval',
    method: 'post',
    data: data
  })
}

/**
 * 删除国高新
 * @param data
 */
export function highTechApprovalDelete(data) {
  return axios({
    url: '/highTechApproval/delete',
    method: 'post',
    data: data
  })
}

/**
 * 查询注册信息
 * @param id
 */
export function enterpriseInformationRegisterQuery(id) {
  return axios({
    url: '/enterpriseInformationRegister/query/' + id,
    method: 'get'
  })
}

/**
 * 跟新注册信息
 * @param data
 */
export function enterpriseInformationRegisterSave(data) {
  return axios({
    url: '/enterpriseInformationRegister/save',
    method: 'post',
    data: data
  })

}

/**
 * 知识产权列表
 * @param data
 */
export function intellectualPropertyQueryAll(data) {
  return axios({
    url: '/intellectualProperty/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询知识产权
 * @param id
 */
export function intellectualPropertyQuery(id) {
  return axios({
    url: '/intellectualProperty/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改知识产权
 * @param data
 */
export function intellectualPropertySave(data) {
  return axios({
    url: '/intellectualProperty/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除知识产权
 * @param data
 */
export function intellectualPropertyDelete(data) {
  return axios({
    url: '/intellectualProperty/delete',
    method: 'post',
    data: data
  })
}

/**
 * 新增修改人力资源情况表
 * @param data
 */
export function humanResourceQuery(id) {
  return axios({
    url: '/humanResource/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改人力资源情况表
 * @param data
 */
export function humanResourceSave(data) {
  return axios({
    url: '/humanResource/save',
    method: 'post',
    data: data
  })
}

/**
 * 查询企业开发活动情况表
 * @param data
 */
export function enterpriseDevelopmentActivityQueryAll(data) {
  return axios({
    url: '/enterpriseDevelopmentActivity/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询知识产权
 * @param id
 */
export function enterpriseDevelopmentActivityQueryAllProperty(id) {
  return axios({
    url: '/enterpriseDevelopmentActivity/queryAllProperty/' + id,
    method: 'get'
  })
}

/**
 * 查询企业研发活动情况单条
 * @param id
 * @param approvalId
 */
export function enterpriseDevelopmentActivityQuery(id, approvalId) {
  return axios({
    url: '/enterpriseDevelopmentActivity/query/' + id + '/' + approvalId,
    method: 'get'
  })
}

/**
 * 新增修改企业研发活动情况
 * @param data
 */
export function enterpriseDevelopmentActivitySave(data) {
  return axios({
    url: '/enterpriseDevelopmentActivity/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除企业研发活动情况
 * @param data
 */
export function enterpriseDevelopmentActivityDelete(data) {
  return axios({
    url: '/enterpriseDevelopmentActivity/delete',
    method: 'post',
    data: data
  })
}

/**
 * 查询年度研发开发费用
 * @param data
 */
export function annualCostQueryAll(data) {
  return axios({
    url: '/annualCost/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询年度研发开发费用单条
 * @param data
 */
export function annualCostQuery(id) {
  return axios({
    url: '/annualCost/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改年度研发开发费用
 * @param data
 */
export function annualCostSave(data) {
  return axios({
    url: '/annualCost/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除年度研发开发费用
 * @param data
 */
export function annualCostDelete(data) {
  return axios({
    url: '/annualCost/delete',
    method: 'post',
    data: data
  })
}

/**
 * 查询上年度高新技术产品
 * @param data
 */
export function highTechProductQueryAll(data) {
  return axios({
    url: '/highTechProduct/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询上年度高新技术产品单条
 * @param data
 */
export function highTechProductQuery(id, approvalId) {
  return axios({
    url: '/highTechProduct/query/' + id + '/' + approvalId,
    method: 'get'
  })
}

/**
 * 新增修改上年度高新技术产品
 * @param data
 */
export function highTechProductSave(data) {
  return axios({
    url: '/highTechProduct/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除上年度高新技术产品
 * @param data
 */
export function highTechProductDelete(data) {
  return axios({
    url: '/highTechProduct/delete',
    method: 'post',
    data: data
  })
}

/**
 * 查询创新能力
 * @param data
 */
export function innovationAbilityAbilityQuery(approvalId) {
  return axios({
    url: '/innovationAbility/ability/query/' + approvalId,
    method: 'get'
  })
}

/**
 * 新增修改创新能力
 * @param data
 */
export function innovationAbilityAbilitySave(data) {
  return axios({
    url: '/innovationAbility/ability/save',
    method: 'post',
    data: data
  })
}

/**
 * 查询科技成果转化
 * @param data
 */
export function innovationAbilityAchievementQueryAll(data) {
  return axios({
    url: '/innovationAbility/achievement/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询科技成果转化单条
 */
export function innovationAbilityAchievementQuery(id) {
  return axios({
    url: '/innovationAbility/achievement/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改科技成果转化
 * @param data
 */
export function innovationAbilityAchievementSave(data) {
  return axios({
    url: '/innovationAbility/achievement/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除科技成果转化
 * @param data
 */
export function innovationAbilityAchievementDelete(data) {
  return axios({
    url: '/innovationAbility/achievement/delete',
    method: 'post',
    data: data
  })
}


/**
 * 查询参与国家标准控制器
 * @param data
 */
export function participateInNationalStandardDesignationQueryAll(data) {
  return axios({
    url: '/participateInNationalStandardDesignation/queryAll',
    method: 'post',
    data: data
  })
}

/**
 * 查询参与国家标准控制器单条
 */
export function participateInNationalStandardDesignationQuery(id) {
  return axios({
    url: '/participateInNationalStandardDesignation/query/' + id,
    method: 'get'
  })
}

/**
 * 新增修改参与国家标准控制器
 * @param data
 */
export function participateInNationalStandardDesignationSave(data) {
  return axios({
    url: '/participateInNationalStandardDesignation/save',
    method: 'post',
    data: data
  })
}

/**
 * 删除参与国家标准控制器
 * @param data
 */
export function participateInNationalStandardDesignationDelete(data) {
  return axios({
    url: '/participateInNationalStandardDesignation/delete',
    method: 'post',
    data: data
  })
}


/*查询主要情况*/
export function queryAdditionalInformation(id) {
  return axios({
    url: '/additionalInformation/query/' + id,
    method: "get"
  })
}
/*保存主要情况*/
export function saveAdditionalInformation(data) {
  return axios({
    url: '/additionalInformation/save',
    method: "post",
    data: data
  })
}

/**
 * 查询封皮页
 * @param approvalId
 */
export function applicationCoverQuery(approvalId) {
  return axios({
    url: '/applicationCover/query/' + approvalId,
    method: 'get'
  })
}

/**
 * 修改封皮页
 * @param data
 */
export function applicationCoverSave(data) {
  return axios({
    url: '/applicationCover/save',
    method: 'post',
    data: data
  })
}

/**
 * 上传项目
 * @param data
 */
export function commonFileSaveFile(data) {
  return axios({
    url: '/common/file/saveFile',
    method: 'post',
    data: data
  })
}

export function commonFileGetMultiFiles(data) {
  return axios({
    url: '/common/file/getMultiFiles',
    method: 'post',
    data: data
  })
}

/**
 * 新增修改国高新详细评测
 * @param data
 */
export function evaluatingSave(data) {
  return axios({
    url: '/evaluating/save',
    method: 'post',
    data: data
  })
}

/**
 * 查看国高新详细评测
 */
export function evaluatingQuery() {
  return axios({
    url: '/evaluating/query',
    method: 'get'
  })
}

/**
 * 查看详细评测报告
 */
export function evaluatingGet() {
  return axios({
    url: '/evaluating/get',
    method: 'get'
  })
} export function generateEvaluating(data) {
  return axios({
    url: '/evaluating/generate',
    method: 'post',
    data: data
  })
}

/**
 * 生成申请资料
 * @param approvalId
 */
export function highTechGeneratePdf(approvalId) {
  return axios({
    url: '/highTech/generatePdf/' + approvalId,
    method: 'get'
  })
}

/**
 * 下载生成资料
 * @param data
 */
export function commonFileGetFileByUrl(data) {
  return axios({
    url: '/common/file/getFileByUrl',
    method: 'post',
    data: data
  })
}

/**
 * 获取级联地区数据
 *
 */
export function getDistricts() {
  return axios({
    url: '/common/district/getDistricts',
    method: 'get'
  })
}

